export { default, default as GatedTemplateModal } from "./GatedTemplateModal";
